import React, { useContext, useEffect, useRef, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import DateHeader from "../../components/DateHeader";
import DataTable, { getCurrentTime } from "../../components/DataTable";
import { toast } from "react-toastify";
import useAxios from "../../common/hook/useAxios";
import { useSearchResults } from "../../context/SearchResultsContext";
import { useNavigate } from "react-router-dom";
import { formatDate } from "../../constant";
const MainPanel = () => {
  const navigate = useNavigate();
  const orderTypesForDropdown = [
    {
      value: 2,
      label: "Toxicology",
    },
    {
      value: 75,
      label: "Urine STI",
    },
    {
      value: 64,
      label: "Chemistry/Blood",
    },
  ];
  const specimentTypesForDropdown = [
    {
      value: 62,
      label: "Oral",
    },
    {
      value: 63,
      label: "Urine",
    },
    {
      value: 65,
      label: "ESwab",
    },
    {
      value: 68,
      label: "Clinical Urine",
    },
    {
      value: 69,
      label: "Other",
    },
    {
      value: 64,
      label: "Chemistry/Blood",
    },
    {
      value: 75,
      label: "Urine/STI",
    },
  ];
  const dataTableRef = useRef();
  const [selectedOrderType, setSelectedOrderType] = useState(
    orderTypesForDropdown[0]?.value,
  );
  const [selectedSpecimenType, setSelectedSpecimenType] = useState(
    specimentTypesForDropdown[0]?.value,
  );
  const [selectedPatientRows, setSelectedPatientRows] = useState({});
  const [selectedRows, setSelectedRows] = useState({});
  const [selectedTemplate, setSelectedTemplate] = useState({});
  const [selectedTemplateForTable, setSelectedTemplateForTable] = useState({});
  const [uploadTriggered, setUploadriggered] = useState(false);
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [labs, setLabs] = useState([]);
  const { request } = useAxios();
  const [error, setError] = useState("");
  const { user } = useContext(AuthContext);
  const { results, setResults } = useSearchResults(); // Access search results from context
  const [selectedValue, setSelectedValue] = useState("");
  const [selectedLab, setSelectedLab] = useState("");
  const [filteredData, setFilteredData] = useState(results);
  const [suggestions, setSuggestions] = useState([]); // Suggestions
  const [checkbox, setCheckbox] = useState("")
  useEffect(() => {
    request(`${process.env.REACT_APP_DROPDOWN_DATA_URL}/GetLabDetails`, {
      method: "GET",
    })
      .then((data) => {
        setLabs(
          data.map((item) => ({
            value: item.LabID,
            label: item.LabName,
          })),
        );
      })
      .catch(() => {
        toast.error("Error occured while fetching labs", {
          autoClose: 3000,
        });
      });
  }, []);
  useEffect(() => {
    setFilteredData(results);
  }, [results]);
  const handleUpload = () => {
    if (Object.values(selectedPatientRows).filter((item) => item === true)) {
      const data = {
        objLab: results
          .filter((item) => {
            const isSelected =
              selectedPatientRows[item.IntelliLabDetailsID] === true;
            return isSelected;
          })
          .map((item) => {
            return {
              intelliLabDetailsID: item.IntelliLabDetailsID,
              patientID: item.PatientID,
              appointmentDate: item.appointmentDate,
              templateID: selectedTemplate.labTemplateID,
              practiceID: user?.PracticeID,
              userID: user?.userId,
              specimenType: selectedSpecimenType,
              collectionTime: getCurrentTime(true),
              orderType: selectedOrderType
            };
          }),
      };
      request(
        `${process.env.REACT_APP_TEMPLATES_URL}/IntelliLab/ApplyTemplate`,
        {
          headers: {
            Authorization: `Bearer ${user.AuthToken}`,
            "Content-Type": "application/json",
          },
          method: "POST",
          data: JSON.stringify(JSON.stringify(data)),
        },
      )
        .then(() => {
          setSelectedTemplateForTable(selectedTemplate);
          handleSearch();
          setSelectedPatientRows({})
        })
        .catch(() => {
          toast.error("Error occured while uploading data", {
            autoClose: 3000,
          });
        });
      setUploadriggered(true);
      // Reset the action state if you want to allow multiple triggers
      setTimeout(() => setUploadriggered(false), 1000); // Optional: Reset after a delay
    } else {
      toast.error("Please select at leaset one patient", { autoClose: 3000 });
    }
  };
  const handleDelete = () => {


    const DeleteData = results
      .filter((item) => selectedPatientRows[item.IntelliLabDetailsID] === true)
      .map((item) => {
        const date = new Date(item.AppointmentDate);
        const formattedDate = date.toISOString().split('T')[0];
        return {
          IntelliLabDetailsID: item.IntelliLabDetailsID,
          DOS: formattedDate,
          PatientID: Number(item?.PatientID)
        };
      });
    // console.log(DeleteData);
    if (DeleteData?.length === 0) {
      toast.error("No Document Selected")
      return
    }
    const data = {
      objLab: {
        PracticeID: user?.PracticeID,
        UserID: user?.userId,
        DeleteData: DeleteData
      }
    };
    // console.log(JSON.stringify(JSON.stringify(data)))
    const url = `${process.env.REACT_APP_TEMPLATES_URL}/IntelliLab/IntelliLabDetails`;
    const response = request(url, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(JSON.stringify(data)),
    })
      .then((res) => {
        if (res > 0) {
          handleSearch()
          toast.success("Record Successfully Deleted")
          setSelectedPatientRows({})
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error("Error occurred while delete record", {
          autoClose: 3000,
        });
      });
  }


  const handleSubmit = async () => {
    if (
      Object.values(selectedRows).filter((item) => item == true).length >
      0
    ) {
      const data = {
        objLab: results
          .filter((item) => selectedRows[item.IntelliLabDetailsID] === true)
          .map((item) => {
            // console.log("Mapping item:", item);

            // const orderTypeMatch = orderTypesForDropdown.find(
            //   (orderType) =>
            //     orderType.value.toString() ===
            //     (selectedTemplate?.orderType?.toString() ?? item.lab.toString())
            // );

            // const labMatch = labs.find(
            //   (lab) =>
            //     lab.value.toString() ===
            //     (selectedTemplate?.labid?.toString() ?? item.lab.toString())
            // );

            return {
              IntelliLabDetailsID: item.IntelliLabDetailsID,
              OrderType: item?.OrderType,
              LabID: item.LabID,
              // templateID: selectedTemplate.labTemplateID,
              PracticeID: user?.PracticeID,
              OrderCodes: item?.OrderCodes,
              CollectionTime: getCurrentTime(true),
            };
          }),
      };

      await request(
        `${process.env.REACT_APP_TEMPLATES_URL}/IntelliLab/GenerateOrders`,
        {
          headers: {
            Authorization: `Bearer ${user.AuthToken}`,
            "Content-Type": "application/json",
          },
          method: "POST",
          data: JSON.stringify(JSON.stringify(data)),
        },
      )
        .then(() => {
          toast.success("Uploaded patients data", {
            autoClose: 3000,
          });
          handleSearch();
          setSelectedRows({})
        })
        .catch(() => {
          toast.error("Error occured while uploading data", {
            autoClose: 3000,
          });
        });
      setUploadriggered(true);
      // Reset the action state if you want to allow multiple triggers
      setTimeout(() => setUploadriggered(false), 1000); // Optional: Reset after a delay
    } else {
      toast.error("Please select at leaset one patient", { autoClose: 3000 });
    }
  };
  const handleSearch = (checkbox=[]) => {
    if (!fromDate) {
      setError("Please select Start Date");
      return;
    }
    if (!toDate) {
      setError("Please select To Date");
      return;
    }
    if (new Date(fromDate) > new Date(toDate)) {
      setError("From date must be before To date.");
      return;
    }
    setError("");
    // Call your API here
    const query = {
      objLab: {
        PracticeID: user?.PracticeID,
        FromDate: formatDate(fromDate),
        ToDate: formatDate(toDate),
        LabID: selectedLab,
        SpecimenType: selectedSpecimenType,
        OrderType: selectedOrderType,
        RequisitionsOnly: selectedValue == "requisitions" ? 1 : 0,
        Encounter: Array.isArray(checkbox) && checkbox.includes("Encounter") ? 1 : 0,
      },
    };
    request(
      `${process.env.REACT_APP_TEMPLATES_URL
      }/Intellilab?sInputJSON=${JSON.stringify(query)}`,
      {
        method: "GET",
      },
    )
      .then((data) => {
        setResults(data); // Store the result in context
      })
      .catch(() => {
        toast.error("Error occured while fetching labs", {
          autoClose: 3000,
        });
      });
  };
  const handleSuggestionClick = async (suggestion) => {
    const requestBody = {
      objLab: {
        PatientID: suggestion?.PatientID, PracticeID: user?.PracticeID, DOS: formatDate(fromDate), LabID: selectedLab, UserName: user?.UserName
      }
    };

    request(`${process.env.REACT_APP_TEMPLATES_URL}/IntelliLab/AddPatient`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${user?.AuthToken}`,
        "Content-Type": "application/json",
      },
      data: JSON.stringify(JSON.stringify(requestBody)),
    })
      .then(() => {
        setTimeout(() => {
          handleSearch();
        }, 1000);

        toast.success("Patient Added Successfully", { autoClose: 2000 });
      })
      .catch(() => {
        toast.error("Error while adding patient", { autoClose: 3000 });
      });
    setSuggestions([]);
  }

  const applyFilter = async (lab, orderType, specimenType, value, checkbox) => {
    await handleSearch(checkbox)
    setCheckbox(checkbox)
    const query = {
      LabID: lab,
      SpecimenType: specimenType,
      OrderType: orderType,
      RequisitionsOnly: value === "requisitions" ? 1 : 0,
    };
    const filtered =
      results !== null &&
      results.length > 0 &&
      results.filter((item) => {

        return (
          (!query.LabID || item.LabID == query.LabID) &&
          (!query.SpecimenType || item.SpecimenType == query.SpecimenType) &&
          (!query.OrderType || item.OrderType == query.OrderType) &&
          (query.RequisitionsOnly === 1 ? item.RequisitionNumber != null && item.RequisitionNumber !== "" : true)
        );
      });
    setFilteredData(filtered);
  };
  return (
    <div>
      <DateHeader
        labs={labs}
        selectedOrderType={selectedOrderType}
        selectedSpecimenType={selectedSpecimenType}
        specimentTypesForDropdown={specimentTypesForDropdown}
        orderTypesForDropdown={orderTypesForDropdown}
        setLabs={setLabs}
        setSelectedOrderType={setSelectedOrderType}
        setSelectedSpecimenType={setSelectedSpecimenType}
        setSelectedTemplate={setSelectedTemplate}
        handleUpload={handleUpload}
        dataTableRef={dataTableRef}
        handleSearch={handleSearch}
        fromDate={fromDate}
        setFromDate={setFromDate}
        toDate={toDate}
        setToDate={setToDate}
        setError={setError}
        error={error}
        selectedLab={selectedLab}
        setSelectedLab={setSelectedLab}
        selectedValue={selectedValue}
        setSelectedValue={setSelectedValue}
        handleFilter={applyFilter}
      />
      <DataTable
        labs={labs}
        selectedOrderType={selectedOrderType}
        selectedSpecimenType={selectedSpecimenType}
        specimentTypesForDropdown={specimentTypesForDropdown}
        orderTypesForDropdown={orderTypesForDropdown}
        dataTableRef={dataTableRef}
        selectedTemplate={selectedTemplateForTable}
        uploadTriggered={uploadTriggered}
        selectedPatientRows={selectedPatientRows}
        setSelectedPatientRows={setSelectedPatientRows}
        handleSubmit={handleSubmit}
        filteredData={filteredData}
        suggestions={suggestions}
        setSuggestions={setSuggestions}
        handleSuggestionClick={handleSuggestionClick}
        handleDelete={handleDelete}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        handleSearch={handleSearch}
        checkbox={checkbox}
      />
    </div>
  );
};
export default MainPanel;
